import React, {Component} from "react";
import {Buffer} from "buffer";
import {Card, Image, Spin, Col, Row, Tabs, Button, Tag, Modal, Divider} from "antd";
import {offerGeneralApiService} from "../../services/offer/OfferGeneralApiService";
import currencyFormat from "../../helper/currencyFormat";
import {CheckCircleTwoTone} from "@ant-design/icons";
import axios from "axios";
import Cookies from "universal-cookie";
import CustomerDataView from "../customer/CustomerDataView";

class DetailGeneralOffer extends Component<any, any> {
    private readonly initState!: any;
    private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());

    constructor(props: any) {
        super(props);
        this.initState = {
            companyCode: "",
            offerCode: "",
            dataDetailOffer: {},
            fetchingDetailGeneralOffer: false,
            fetchPaymentHistory: false,
            dataPaymentHistory: [],
            totalPayment: 0,
            fetchingPo: false,
            modalPo: false,
            dataPo: {},
            otrCatalogueShow: false,
            otrCatalogue: 0,
            urlImageCatalogue: "",
            phoneNumberOwner: "",
            phoneNumberAlternative_owner: "",
            phoneNumberOrderMaker: "",
        };
        this.state = {...this.initState};
    }

    async componentDidMount() {
        await this.promisedSetState({
            offerCode: this.props.offerCode,
            companyCode: this.props.companyCode,
            fetchingDetailGeneralOffer: true,
        });

        await this.showOfferDetail();
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.offerCode !== prevProps.offerCode) {
            await this.promisedSetState({
                offerCode: this.props.offerCode,
                companyCode: this.props.companyCode,
                fetchingDetailGeneralOffer: true,
            });
        }

        if (this.props.companyCode !== prevProps.companyCode) {
            await this.promisedSetState({
                offerCode: this.props.offerCode,
                companyCode: this.props.companyCode,
                fetchingDetailGeneralOffer: true,
            });
        }

        if (this.props.time !== prevProps.time) {
            await this.showOfferDetail();
        }
    }

    showOfferDetail = async () => {
        await offerGeneralApiService
            .getDetailOffer({
                offerCode: this.state.offerCode,
                companyCode: this.state.companyCode,
            }).then(async (value) => {
                await this.promisedSetState({
                    dataDetailOffer: value.data.data,
                    fetchingDetailGeneralOffer: false,
                    phoneNumberOwner:
                        value.data.data?.contact?.phone_number_owner.substring(0, 2) === "08"
                            ? value.data.data?.contact?.phone_number_owner.replace(/^.{2}/g, "628")
                            : value.data.data?.contact?.phone_number_owner,
                    phoneNumberAlternative_owner:
                        value.data.data?.contact?.phone_number_alternative_owner.substring(0, 2) === "08"
                            ? value.data.data?.contact?.phone_number_alternative_owner.replace(/^.{2}/g, "628")
                            : value.data.data?.contact?.phone_number_alternative_owner,
                    phoneNumberOrderMaker:
                        value.data.data?.contact?.phone_number_order_maker.substring(0, 2) === "08"
                            ? value.data.data?.contact?.phone_number_order_maker.replace(/^.{2}/g, "628")
                            : value.data.data?.contact?.phone_number_order_maker,
                });
                const sleep = (waitTimeInMs: number) => new Promise((resolve) => setTimeout(resolve, waitTimeInMs));
                await sleep(100);
            }).catch(async (reason) => {
                await this.promisedSetState({
                    dataDetailOffer: {},
                    fetchingDetailGeneralOffer: false,
                    phoneNumberOwner: "",
                    phoneNumberAlternative_owner: "",
                    phoneNumberOrderMaker: "",
                });
            });
    };

    fetchPo = async (version: string) => {
        this.setState({
            modalPo: true,
            fetchingPo: true,
        });

        let params = {};
        if (version === "v1") {
            params = {
                leasingCode: this.state.dataDetailOffer?.credit?.finco_code?.toUpperCase(),
                trackNumber: this.state.dataDetailOffer?.credit?.po_track_number,
            };
        }
        if (version === "v2") {
            params = {
                poNumber: this.state.dataDetailOffer?.credit?.po_code?.toUpperCase(),
            };
        }

        await axios({
            method: "get",
            url: "https://asia-southeast2-amh-b2b.cloudfunctions.net/api-b2b/public/fetch-track-number",
            params: params,
            timeout: 100000000000,
            headers: {"Content-Type": "application/json"},
        })
            .then((response) => {
                this.setState({
                    fetchingPo: false,
                    dataPo: response.data?.data,
                });
                console.log(response);
            })
            .catch((response) => {
                this.setState({
                    fetchingPo: false,
                    dataPo: {
                        error: "error",
                    },
                });
            });
    };

    onPropsChat = (data: any) => {
        this.showOfferDetail();
    };

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        const listCommissionUsedName = [];
        for (const item of this.state.dataDetailOffer?.detail_commission ?? []) {
            listCommissionUsedName.push(item?.code);
        }

        return (
            <React.Fragment>
                <div style={this.state.fetchingDetailGeneralOffer ? {} : {display: "none"}} className={`spinCenter`}>
                    <Spin size="large"/>
                </div>
                <Tabs style={!this.state.fetchingDetailGeneralOffer ? {} : {display: "none"}} defaultActiveKey="1">
                    <Tabs.TabPane tab="Offer" key="1">
                        <Row>
                            <Col xs={24} xl={12} style={{padding: 10}}>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Kode Offer:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.transaction_code}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Tanggal Offer:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.transaction_time?.replace("T", " ")?.substring(0, 19)}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`} style={this.state.dataDetailOffer?.purchase_method === "credit" ? {} : {display: "none"}}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Tanggal Masuk B2B:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.survey_created_time?.replace("T", " ")?.substring(0, 19)}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`} style={this.state.dataDetailOffer?.purchase_method === "credit" && this.state.dataDetailOffer?.tracking_code ? {} : {display: "none"}}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Tracking Code B2B:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.tracking_code ?? "-"}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Sumber:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.source}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Tipe Kepemilikan:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.document_ownership_type}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Tipe Offer:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.transaction_type}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Metode Pembelian:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.purchase_method}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Area:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.area?.toUpperCase()}
                                    </Col>
                                </Row>
                                <Divider/>
                                <span style={this.state.dataDetailOffer?.amarta_vip_uid ? {} : {display: "none"}}>
                                    <CheckCircleTwoTone twoToneColor="#52c41a"/>
                                    &nbsp;<i style={{fontSize: "85%", color: "#52c41a"}}>Login with AmartaVip account</i>
                                </span>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Kode Agen:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.agent_code}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nama Agen:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.agent_name?.toUpperCase() ?? "-"}
                                    </Col>
                                </Row>
                                <div style={this.state.dataDetailOffer?.mediator_code ? {} : {display: "none"}}>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Kode Mediator:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailOffer?.mediator_code}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Nama Mediator:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailOffer?.mediator_name?.toUpperCase() ?? "-"}
                                        </Col>
                                    </Row>
                                </div>
                                <Divider/>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nomor KTP Pemilik:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.id_card_owner?.id_card_number}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nama Pemilik:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.id_card_owner?.full_name?.toUpperCase()}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nomor Telpon Pemilik:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.contact?.phone_number_owner}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Catatan Offer:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.notes ?? ""}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`} style={this.state.dataDetailOffer?.stock_code ? {} : {display: "none"}}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Book Kode Stock:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.stock_code ?? ""}
                                    </Col>
                                </Row>
                                <br/>
                                <Row className={`pt-5`} style={this.state.dataDetailOffer?.stock_number ? {} : {display: "none"}}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`} style={{color: "#cc0d0d"}}>
                                        <i>Book Nomor Mesin:</i>
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.stock_number ?? ""}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`} style={this.state.dataDetailOffer?.stock_closing_date ? {} : {display: "none"}}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`} style={{color: "#cc0d0d"}}>
                                        <i>Tanggal Minimal Pemenuhan:</i>
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.stock_closing_date?.substring(0, 10) ?? ""}
                                    </Col>
                                </Row>
                                <br/>

                                <div style={this.state.dataDetailOffer?.offer_status === "OPEN" ? {} : {display: "none"}}>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Status Offer:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            <b>
                                                <Tag color="processing">{this.state.dataDetailOffer?.offer_status}</Tag>
                                            </b>
                                        </Col>
                                    </Row>
                                </div>

                                <div style={this.state.dataDetailOffer?.offer_status === "ORDER" ? {} : {display: "none"}}>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Status Offer:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            <b>
                                                <Tag color="processing">{this.state.dataDetailOffer?.offer_status}</Tag>
                                            </b>
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Order Code:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailOffer?.order_code}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Order Time:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailOffer?.order_time}
                                        </Col>
                                    </Row>
                                </div>

                                <div style={this.state.dataDetailOffer?.offer_status === "CANCEL" ? {} : {display: "none"}}>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Status Offer:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            <b>
                                                <Tag color="error">{this.state.dataDetailOffer?.offer_status}</Tag>
                                            </b>
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Alasan Cancel:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailOffer?.cancel_reason}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Cancel Time:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailOffer?.cancel_order_time}
                                        </Col>
                                    </Row>
                                </div>

                                <Row className={`pt-15`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        QC Admin:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.qc_admin ?? "-"}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        QC Time:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.qc_time?.replace("T", " ")?.substring(0, 19) ?? "-"}
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={24} xl={12} style={{padding: 10}}>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nomor Polisi:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.product?.serial_number}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Brand:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.product?.brand_name}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Model:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.product?.model_name}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Kode Variant:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.product?.variant_code}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Variant:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.product?.variant_name}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Kode / Nama Warna:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.product?.color_code} - {this.state.dataDetailOffer?.product?.color_name}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Tahun Kendaraan:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.product?.year}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`} style={this.state.dataDetailOffer?.order?.product ? {} : {display: "none"}}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nosin Order:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.order?.product}
                                    </Col>
                                </Row>

                                <Divider/>

                                <div style={this.state.dataDetailOffer?.purchase_method === "credit" ? {} : {display: "none"}}>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Kode Finco:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailOffer?.credit?.finco_code?.toUpperCase()}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Nama Finco:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailOffer?.credit?.finco_name?.toUpperCase()}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Nilai Produk (harga taksir):
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {currencyFormat(this.state.dataDetailOffer?.product?.price)}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Nilai Pendanaan:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {currencyFormat(this.state.dataDetailOffer?.credit?.disbursed_amount)}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Tenor / Cicilan:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailOffer?.credit?.tenor} @ {this.state.dataDetailOffer?.credit?.installment_amount}
                                        </Col>
                                    </Row>

                                    <Divider/>
                                    <Row>
                                        {this.state.dataDetailOffer?.document?.map((item: any, i: number) =>
                                            <Col key={i} span={6} style={{textAlign: "center"}}>
                                                <span className={`col-grey-small-80`}>{item?.type === "registration" ? "STNK" : item?.type === "ownership" ? "BPKB" : item?.type === "notice" ? "notice" : item?.type}</span><br/>
                                                <Image style={{height: "50px"}} src={item?.image}/>
                                            </Col>
                                        )}
                                    </Row>
                                    <Divider/>

                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Nomor Kontrak:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailOffer?.credit?.contract_number}
                                        </Col>
                                    </Row>
                                    <Row className={`pt-5`}>
                                        <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                            Kode PO:
                                        </Col>
                                        <Col xs={24} xl={18}>
                                            {this.state.dataDetailOffer?.credit?.po_code?.toUpperCase()}
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Data Komisi" key="3">
                        <Row>
                            <Col xs={24} xl={12} style={{padding: 10}}>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nilai Produk (harga taksir):
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {currencyFormat(this.state.dataDetailOffer?.product?.price)}
                                    </Col>
                                </Row>

                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Kode Komisi:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {listCommissionUsedName.toString()}
                                    </Col>
                                </Row>

                                <Divider style={{marginTop: 10, marginBottom: 10, marginRight: 20}}/>

                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Nilai Pendanaan:
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        <b>{currencyFormat(this.state.dataDetailOffer?.credit?.disbursed_amount)}</b>
                                    </Col>
                                </Row>

                                <Divider style={{marginTop: 10, marginBottom: 10, marginRight: 20}}/>

                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Komisi Finco:
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat(this.state.dataDetailOffer?.credit?.finco_commission)}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Komisi Agent (Mediator):
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat(this.state.dataDetailOffer?.credit?.agent_commission || 0)}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Komisi Sales (Amarta VIP-agent):
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat(this.state.dataDetailOffer?.credit?.sales_commission || 0)}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={8} className={`col-grey-small-90`}>
                                        Komisi SPV:
                                    </Col>
                                    <Col xs={24} xl={16}>
                                        {currencyFormat(this.state.dataDetailOffer?.credit?.spv_commission || 0)}
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={24} xl={12}>
                                <b>Rekening Konsumen</b>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Bank:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.bank_account?.bank_short_name?.toUpperCase()}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nama Bank:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.bank_account?.bank_name?.toUpperCase()}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nomor Akun:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.bank_account?.account_number?.toUpperCase()}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nama Akun:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.bank_account?.account_name?.toUpperCase()}
                                    </Col>
                                </Row>
                                <br/>
                                <b>Rekening Agent</b>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Bank:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.agent_bank_account?.bank_short_name?.toUpperCase()}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nama Bank:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.agent_bank_account?.bank_name?.toUpperCase()}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nomor Akun:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.agent_bank_account?.account_number?.toUpperCase()}
                                    </Col>
                                </Row>
                                <Row className={`pt-5`}>
                                    <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                        Nama Akun:
                                    </Col>
                                    <Col xs={24} xl={18}>
                                        {this.state.dataDetailOffer?.agent_bank_account?.account_name?.toUpperCase()}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Data Konsumen" key="customer">
                        <Row>
                            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                <Card style={{marginLeft: 20, marginRight: 20, marginTop: 10}} size="small" hoverable={true}>
                                    Data Pemilik
                                    <Divider style={{marginTop: 10, marginBottom: 10}}/>
                                    <CustomerDataView
                                        idCard={this.state?.dataDetailOffer?.id_card_owner}
                                        address={this.state.dataDetailOffer?.address_owner}
                                        phoneNumber={this.state.dataDetailOffer?.contact?.phone_number_owner}
                                        phoneNumberWaAvailable={this.state.dataDetailOffer?.contact?.phone_number_wa_available_owner}
                                        alternativePhoneNumber={this.state.dataDetailOffer?.contact?.phone_number_alternative_owner}
                                    />
                                </Card>
                            </Col>
                            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                <Card style={{marginLeft: 20, marginRight: 20, marginTop: 10}} size="small" hoverable={true}>
                                    Kartu Keluarga
                                    <Divider style={{marginTop: 10, marginBottom: 10}}/>
                                    <Row>
                                        <Col xs={24} xl={12}>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    Nomor KK:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailOffer?.family_register_owner?.family_register_number}
                                                </Col>
                                            </Row>
                                            <Row className={`pt-5`}>
                                                <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                                    Gambar KK:
                                                </Col>
                                                <Col xs={24} xl={18}>
                                                    {this.state.dataDetailOffer?.family_register_owner?.family_register_image && (
                                                        <a target={"_blank"} rel="noreferrer" href={this.state.dataDetailOffer?.family_register_owner?.family_register_image}>
                                                            {" "}
                                                            Lihat Image{" "}
                                                        </a>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                </Tabs>

                <Modal
                    open={this.state.modalPo}
                    title={`Track Number ${this.state.dataDetailOffer?.credit?.po_track_number}`}
                    onOk={() => this.setState({modalPo: false})}
                    onCancel={() => this.setState({modalPo: false})}
                    cancelText={"Tutup"}
                    okText={false}
                    footer={[
                        <Button key="back" type="primary" onClick={() => this.setState({modalPo: false})}>
                            Tutup
                        </Button>,
                    ]}
                >
                    <div style={this.state.fetchingPo ? {} : {display: "none"}} className={`spinCenter`}>
                        <Spin size="large"/>
                    </div>
                    <div style={!this.state.fetchingPo ? {} : {display: "none"}}>
                        <pre>{JSON.stringify(this.state.dataPo, undefined, 3)}</pre>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

export default DetailGeneralOffer;